"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { useEffect, useRef } from "react";
import { pushGtmEvent, setGtmEnabled } from "@package/util/utils/gtm";
import { GTM_EVENTS } from "@package/util/utils/gtmEvents";
import { useGtm } from "@package/util/context/GtmContext";

export default function GtmTracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const prevPathRef = useRef("");
  const companyDetailsTrackedRef = useRef(false);
  const { gtmEnabled, companyDetails } = useGtm();

  // Sync GTM enabled state to the utility function
  useEffect(() => {
    setGtmEnabled(gtmEnabled);
  }, [gtmEnabled]);

  useEffect(() => {
    if (!companyDetails || companyDetailsTrackedRef.current) {
      return;
    }

    companyDetailsTrackedRef.current = true;

    pushGtmEvent(GTM_EVENTS.COMPANY_DETAILS_LOADED, {
      company_details: companyDetails,
    });
  }, [companyDetails]);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const path = pathname || "/";
    const query = searchParams?.toString() || "";

    if (prevPathRef.current === path + "?" + query) {
      return;
    }

    prevPathRef.current = path + "?" + query;

    pushGtmEvent(GTM_EVENTS.PAGE_VIEW, {
      page_path: path,
      page_query: query,
      page_title: document.title,
      company_details: companyDetails,
    });
  }, [pathname, searchParams, companyDetails]);

  return null;
}
